import "./index.scss";
import "../../App.scss";
import { useEffect } from "react";
import { PropTypes } from "prop-types";

/**
 * Welcome screen component that displays the main entry point of the application.
 * Shows a welcome message and guides users to choose their difficulty level.
 *
 * @param {Object} props - Component props
 * @param {Object} props.config - Application configuration object containing app name
 * @returns {JSX.Element} Welcome screen with guide character and modal
 */
const Welcome = ({ config }) => {
  useEffect(() => {
    document.title = `${config.AppName} - Home`;
  }, []);
  return (
    <div className="welcome_container all_pages_container">
      <div className="welcome_seasonstree">
        <div className="welcome_modal">
          <div className="welcome_guidecharacter" />
          <h1 className="welcome_modaltext">Welcome Back!</h1>
          <h1 className="welcome_modaltext">Choose your Level!</h1>
        </div>
        <span className="welcome_pointer" aria-hidden="true">
          ▼
        </span>
      </div>
    </div>
  );
};

export default Welcome;

Welcome.propTypes = {
  config: PropTypes.object,
};
